import React from "react";
import { Box, TextField } from "@mui/material";
import { NameParsePreview } from "../../../tenant/components/common/NameParsePreview";

/**
 * Componente custom para el campo TenantProfile.legalName ("Datos del Cliente").
 *
 * Recupera la UX de carga de editoriales persona física: cuando el valor viene como
 * "Apellidos, Nombres" (con coma), muestra un preview con los apellidos/nombres parseados.
 * No depende de personType (campo hermano, no disponible acá): se gatea por el formato del
 * valor — sólo se muestra el preview si hay coma, así una razón social de persona jurídica
 * (sin coma) no dispara el aviso de formato.
 *
 * Llená/editá este archivo en `develop`. El generador lo emite como stub estable en `base`
 * (merge-safe). Recibe los mismos props que un control estándar del form.
 */
export interface TenantProfileLegalNameCustomFieldProps {
  value: any;
  onChange: (value: any) => void;
  error?: boolean;
  helperText?: string;
  label?: string;
  description?: string;
}

export const TenantProfileLegalNameCustomField: React.FC<
  TenantProfileLegalNameCustomFieldProps
> = ({ value, onChange, error, helperText, label, description }) => {
  const showPreview = typeof value === "string" && value.includes(",");
  return (
    <Box>
      <TextField
        fullWidth
        label={label}
        value={value ?? ""}
        error={error}
        helperText={helperText || description}
        onChange={(e) => onChange(e.target.value)}
      />
      {showPreview && <NameParsePreview value={value} />}
    </Box>
  );
};
